import { Map, List, fromJS } from 'immutable'
import { actions } from './actions'
import { actions as authAction } from '../authentication/actions'
import Util from 'utils/Util'

const initialState = Map({
    basketItems: List([]), // Local basket Items
    hasPlatterItems: false,
    cartPatchInProgress: false,
    cartUpdateLoader: false,
    basketResponse: null,
    cartPatchError: null,
    checkoutInProgress: false,
    checkoutResponse: null,
    checkoutError: null,
    placeOrderResponse: null,
    placeOrderInProgress: false,
    placeOrderError: null,
    getCartInProgress: false,
    getCartError: null,
    suggestiveSelling: List([]),
    suggestiveItemsRawData: null,
    deliveryNotes: '',
    basketUpdates: {},
    deferredPatchRequests: List([]),
    glolbalError: '',
    canAddItems: true,
    updateShippingInProgress: false,
    refreshBasketRequired: false,
    reorderDone: false,
    promoResonse: null,
    upavailableChangeInfo: {},
    placeOrderReqBdy: null,
    applyingReferralCode: false,
    referralCodeResponse: {
        referral_code: '',
        source: '',
        redemption_response: {
            status: '',
            redeemed: false,
        },
    },
    preOrderDateTimePicker:null,
    preOrderUtensilOptions:'No',
    preOrderCancelInProgress:null,
    preOrderCancelResponse:null
})

const basket = (state = initialState, action) => {
    const { type, payload } = action

    switch (type) {
        case actions.BASKET_GLOBAL_ERROR: {
            return state.merge({
                glolbalError: payload,
                canAddItems: action.canAddItems,
            })
        }
        case actions.RESET_DELIVERY_NOTES: {
            return state.merge({
                deliveryNotes: '',
            })
        }
        case actions.SET_BASKET_ITEMS: {
            const items = Array.isArray(payload) ? payload : []
            const hasPlatterItems = Util.checkForPreOrderItems(items)
            return state.merge({
                basketItems: fromJS(payload),
                hasPlatterItems,
            })
        }

        case actions.SET_DEFERRED_PATCH_REQUESTS: {
            return state.merge({
                deferredPatchRequests: fromJS(payload),
            })
        }

        case actions.SET_BASKET_UPDATES: {
            return state.merge({
                basketUpdates: fromJS(payload),
            })
        }

        case actions.PATCH_CART_START: {
            return state.merge({
                cartPatchInProgress: true,
                updateShippingInProgress: true,
                cartUpdateLoader: true,
            })
        }

        case actions.PATCH_BASKET_ITEM: {
            return state.merge({
                cartPatchInProgress: true,
            })
        }

        case actions.PATCH_CART_SUCCESS: {
            return state.merge({
                cartPatchInProgress: false,
                cartPatchError: null,
                basketResponse: fromJS(payload.basketResponse),
                basketUpdates: fromJS(payload.basketUpdates),
                reorderDone: false,
                cartUpdateLoader: false,
            })
        }

        case actions.UPDATE_SHIPPING: {
            return state.merge({
                updateShippingInProgress: true,
            })
        }

        case actions.UPDATE_SHIPPING_DONE: {
            return state.merge({
                updateShippingInProgress: false,
            })
        }

        case actions.SET_REFRESH_BASKET_REQUIRED: {
            return state.merge({
                refreshBasketRequired: fromJS(payload),
            })
        }

        case actions.PATCH_CART_FAILED: {
            return state.merge({
                cartPatchInProgress: false,
                cartPatchError: fromJS(payload),
                cartUpdateLoader: false,
            })
        }

        case actions.GET_BASKET: {
            return state.merge({
                getCartInProgress: true,
            })
        }

        case actions.GET_BASKET_SUCCESS: {
            return state.merge({
                getCartInProgress: false,
                basketResponse: fromJS(payload.basketResponse),
                basketUpdates: fromJS(payload.basketUpdates),
                reorderDone: false,
            })
        }

        case actions.GET_BASKET_FAILED_DONE: {
            return state.merge({
                getCartInProgress: false,
                getCartError: fromJS(payload),
            })
        }

        case actions.TRACKING_SUGGESTIVE_ITEMS: {
            return state.merge({
                suggestiveItemsRawData: fromJS(payload),
            })
        }

        case actions.GET_SUGGESTIVE_SELLING_SUCCESS: {
            return state.merge({
                suggestiveSelling: fromJS(payload),
            })
        }

        case actions.GET_SUGGESTIVE_SELLING_FAILED: {
            return state.merge({
                suggestiveSelling: List([]),
            })
        }

        case actions.CHECKOUT: {
            return state.merge({
                checkoutInProgress: true,
            })
        }

        case actions.CHECKOUT_SUCCESS: {
            return state.merge({
                checkoutInProgress: false,
                checkoutResponse: fromJS(payload),
                checkoutError: null,
            })
        }

        case actions.CHECKOUT_FAILED: {
            return state.merge({
                checkoutInProgress: false,
                checkoutResponse: null,
                checkoutError: fromJS(payload),
            })
        }

        case actions.PLACE_ORDER: {
            return state.merge({
                placeOrderInProgress: true,
            })
        }

        case actions.PLACE_ORDER_SUCCESS: {
            return state.merge({
                placeOrderResponse: fromJS(payload),
                placeOrderInProgress: false,
                placeOrderError: null,
            })
        }

        case actions.PLACE_ORDER_FAILED: {
            return state.merge({
                placeOrderInProgress: false,
                placeOrderError: fromJS(payload),
            })
        }
        case actions.UPDATE_CART_ITEM: {
            const { key, value, index } = action
            let basketItems = state.get('basketItems')

            basketItems = basketItems.update(index, item => item.set(key, value))
            return state.merge({
                basketItems,
                upavailableChangeInfo: { key, value, index },
            })
        }

        case actions.SET_DELIVERY_NOTES: {
            return state.merge({ deliveryNotes: payload })
        }

        case actions.CLEAR_BASKET: {
            return state.merge({
                cartPatchInProgress: true,
            })
        }

        case actions.CLEAR_BASKET_SUCCESS: {
            return state.merge({
                cartPatchInProgress: false,
            })
        }

        case actions.CLEAR_BASKET_FAILED: {
            return state.merge({
                cartPatchInProgress: false,
            })
        }

        case actions.APPLY_PROMO_CODE:
        case actions.REMOVE_PROMO_CODE: {
            return state.merge({
                cartPatchInProgress: true,
            })
        }

        case actions.APPLY_PROMO_CODE_SUCCESS:
        case actions.REMOVE_PROMO_CODE_SUCCESS: {
            return state.merge({
                cartPatchInProgress: false,
                basketResponse: fromJS(payload),
            })
        }

        case actions.CLEAR_FORM_ERRORS: {
            return state.merge({
                placeOrderError: null,
                checkoutError: null,
            })
        }

        case actions.CLEAR_PREV_ORDER: {
            return state.merge({
                placeOrderResponse: null,
            })
        }

        case actions.REORDER_ITEMS_DONE: {
            return state.merge({
                reorderDone: true,
            })
        }

        case actions.PROMO_CODE_RESULT: {
            return state.merge({
                promoResponse: payload,
            })
        }

        case authAction.SIGN_OUT_SUCCESS: {
            return initialState
        }

        case actions.APPLY_REFERRAL_CODE: {
            return state.merge({
                applyingReferralCode: true,
            })
        }
        case actions.APPLY_REFERRAL_CODE_SUCCESS: {
            return state.merge({
                referralCodeResponse: payload,
                applyingReferralCode: false,
            })
        }
        case actions.APPLY_REFERRAL_CODE_FAILED: {
            return state.merge({
                referralCodeResponse: {
                    referral_code: '',
                    source: '',
                    redemption_response: {
                        status: '',
                        redeemed: false,
                    },
                },
                applyingReferralCode: false,
            })
        }

        case actions.SET_PRE_ORDER_DATE_TIME_DETAILS: {
            return state.merge({
                preOrderDateTimePicker:payload
            })
        }

        case actions.SET_PRE_ORDER_UTENSIL_DETAILS: {
            return state.merge({
                preOrderUtensilOptions:payload
            })
        }

        case actions.PREORDER_CANCEL:{
            return state.merge({
                preOrderCancelInProgress:true
            })
        }

        case actions.PREORDER_CANCEL_SUCCESS:{
            return state.merge({
                preOrderCancelInProgress:false,
                preOrderCancelResponse:payload
            })
        }

        case actions.PREORDER_CANCEL_FAILED:{
            return state.merge({
                preOrderCancelInProgress:true,
                preOrderCancelResponse:payload
            })
        }

        default:
            return state
    }
}

export default basket
